<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      tableClass?: HTMLAttributes['class'];
      borderRounded?: boolean;
      spacedRows?: boolean;
    }>(),
    {
      borderRounded: true,
    },
  );
</script>

<template>
  <div
    :class="
      cn(
        borderRounded && !spacedRows && 'rounded overflow-y-hidden overflow-x-auto min-h-full',
        tableClass,
      )
    "
  >
    <table :class="cn('w-full caption-bottom', props.class)">
      <slot />
    </table>
  </div>
</template>

<style lang="postcss">
  @reference "../../globals.css";

  .model-table {
    tbody tr:not([data-slot='table-empty']) {
      &:nth-child(odd) {
        background-color: var(--table-odd);

        &:hover {
          background-color: var(--table-odd-hover) !important;
        }
      }

      &:nth-child(even) {
        background-color: var(--table-even);

        &:hover {
          background-color: var(--table-even-hover) !important;
        }
      }
    }

    th,
    td {
      border-color: var(--table-border);
    }

    thead tr {
      background-color: var(--table-header) !important;

      th {
        background-color: var(--table-header) !important;
      }
    }
  }
</style>
